var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearMeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 114,
    viewBox: "0 0 94 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.89 73C10.33 76.165 7 80.195 7 84.58C7 94.75 24.91 103 47 103C69.09 103 87 94.75 87 84.58C87 80.195 83.67 76.165 78.11 73",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9898 28H42.0098C27.6598 28 17.9848 43.35 23.6398 57.14C24.0041 58.0637 24.6352 58.858 25.4527 59.4217C26.2701 59.9853 27.2369 60.2928 28.2298 60.305H31.7448C32.9298 60.305 33.9648 61.155 34.2498 62.355L38.7748 81.285C39.7198 85.235 43.1098 88 46.9998 88C50.8898 88 54.2798 85.23 55.2248 81.285L59.7498 62.355C59.8739 61.7813 60.1885 61.2664 60.6424 60.8942C61.0963 60.522 61.6628 60.3143 62.2498 60.305H65.7698C66.7626 60.2928 67.7294 59.9853 68.5469 59.4217C69.3643 58.858 69.9954 58.0637 70.3598 57.14C76.0198 43.345 66.3398 28 51.9898 28Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 15.5C59.5 18.8152 58.183 21.9946 55.8388 24.3388C53.4946 26.683 50.3152 28 47 28C43.6848 28 40.5054 26.683 38.1612 24.3388C35.817 21.9946 34.5 18.8152 34.5 15.5C34.5 12.1848 35.817 9.00537 38.1612 6.66117C40.5054 4.31696 43.6848 3 47 3C50.3152 3 53.4946 4.31696 55.8388 6.66117C58.183 9.00537 59.5 12.1848 59.5 15.5Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_25",
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_25",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearMeIcon);
export default __webpack_public_path__ + "static/media/near-me-icon.f5901fe67db25e052a2e06ff0deb52ca.svg";
export { ForwardRef as ReactComponent };